<template>
  <!-- <a-layout class="p-gap-20" style="font-size:14px"> -->
  <a-layout class="layout-max">
    <div class="search-bar">
      <feedback v-model="feedbackVisible" />
      <div style="padding-bottom: 12px">
        <a-input-search
          v-model="searchWord"
          placeholder="搜索项目、工作进展、会议纪要、项目文档（可穿透文档）、共享云盘、专家访谈等"
          @search="
            getList(true, true);
            $route.query.key = '';
          "
        />
      </div>
      <div style="min-height: 32px; position: relative">
        <a-select v-model="sector" style="width: 150px" :disabled="expendSelectDisable">
          <a-select-option key="all">全部Sector</a-select-option>
          <a-select-option v-for="item in sectorList" :key="item.id">{{ item.name }}</a-select-option>
        </a-select>
        <a-select
          showSearch
          :disabled="expendSelectDisable"
          placeholder="项目关联人"
          style="width: 150px; margin: 0 20px"
          :filterOption="false"
          :showArrow="false"
          @search="fetchUser"
          @change="userChange"
          @popupScroll="popupScroll"
          @dropdownVisibleChange="dropdownVisibleChange"
        >
          <a-spin v-if="fetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="d in userList" :key="d.id">{{ d.nickname }}</a-select-option>
        </a-select>
        <a-date-picker
          :disabled="expendSelectDisable"
          style="width: 200px"
          @ok="getList(true, true)"
          showTime
          v-model="startTime"
          format="YYYY-MM-DD HH:mm:ss"
        />
        <a-date-picker
          :disabled="expendSelectDisable"
          style="width: 200px; margin: 0 20px"
          @ok="getList(true, true)"
          showTime
          v-model="endTime"
          format="YYYY-MM-DD HH:mm:ss"
        />

        <a-button class="feedback" type="link" @click="feedbackVisible = true"> <a-icon type="frown" /> 搜索结果不满意 </a-button>
      </div>
    </div>
    <!-- 左边菜单 -->
    <a-layout :class="current[0] == 4 ? 'share-layout' : 'layout'">
      <a-layout-sider width="220" class="bg_white">
        <a-menu v-model="current" mode="inline" @select="typeChange" style="margin-top: 20px">
          <template v-for="menu in typeList">
            <a-menu-item :key="menu.value">
              <span>{{ menu.label }}</span> <span v-if="menu.new" class="new">NEW</span>
              <span class="count" v-if="countMap[menu.value]">({{ countMap[menu.value] }})</span>
              <span class="count" v-if="menu.value === -1 && countAll">({{ countAll }})</span>
            </a-menu-item>
            <!-- // 专家访谈和飞阅会评论 -->
            <a-menu-item v-for="item in menu.children" :key="item.value" class="expertPath">
              <span>{{ item.label }}</span> <span v-if="item.new" class="new">NEW</span>
              <span class="count" v-if="countMap[item.value]">({{ countMap[item.value] }})</span>
            </a-menu-item>
          </template>
        </a-menu>
      </a-layout-sider>
      <a-layout-content>
        <div class="content-item" v-if="empty && !loading">搜索到0个“{{ searchWordOld }}”相关的内容</div>
        <!-- 项目 -->
        <div class="content-item" v-if="(current[0] == -1 && company.total) || current[0] == 1">
          <a-spin :spinning="company.loading">
            <header>
              <span class="title">项目</span>
              搜索到<span class="total">{{ company.total }}</span
              >个“{{ searchWordOld }}”相关的项目
              <a href="javaScript:;" @click="toProject" data-ga-id="搜索-点击去项目列表中查看">(去项目列表中查看)</a>
            </header>
            <div style="cursor: pointer">
              <a-table
                size="small"
                :scroll="{ x: 1170 }"
                :columns="projectColumns"
                :dataSource="company.list"
                :pagination="false"
                :rowKey="row => row.projectId"
                :customRow="
                  record => {
                    return {
                      on: {
                        // 事件
                        click: event => {
                          toProjectDetail(record.projectId, '项目');
                        } // 点击行
                      }
                    };
                  }
                "
              >
                <div slot="name" slot-scope="row" style="display: flex">
                  <img :src="row.logoPath" class="avatar img-24" />
                  <div v-html="row.projectName" class="text-over project-name"></div>
                </div>
                <span slot="brief" slot-scope="record">
                  <a-popover overlayClassName="overlay-text">
                    <template slot="content">
                      <div v-html="record"></div>
                    </template>
                    <div v-html="record" class="text-over"></div>
                  </a-popover>
                </span>
                <span slot="dldm" slot-scope="record">
                  <a-popover overlayClassName="overlay-text">
                    <template slot="content">
                      <div v-html="record ? record.join(',') : ''"></div>
                    </template>
                    <div class="text-over">{{ record ? record.join(',') : '' }}</div>
                  </a-popover>
                </span>
                <span slot="fullName" slot-scope="record">
                  <a-popover overlayClassName="overlay-text" v-if="record">
                    <template slot="content">
                      <div v-html="record"></div>
                    </template>
                    <div v-if="record" v-html="record" class="text-over"></div>
                    <span v-else>-</span>
                  </a-popover>
                </span>
                <span slot="thirdName" slot-scope="record">
                  <a-popover overlayClassName="overlay-text">
                    <template slot="content" v-if="record">
                      <div v-html="record"></div>
                    </template>
                    <div v-if="record" v-html="record" class="text-over"></div>
                    <span v-else>-</span>
                  </a-popover>
                </span>
                <span slot="xiniuUrl" slot-scope="record">
                  <a-tooltip :overlayStyle="{ fontSize: '12px' }">
                    <template slot="title"> 已绑定烯牛数据，点击跳转。 </template>
                    <a-button @click.stop="toXiniu(record)" type="link"><a-icon type="link" v-if="record"></a-icon></a-button>
                  </a-tooltip>
                </span>
              </a-table>
            </div>

            <more data-ga-id="搜索-点击查看更多" data-ga-value="项目" v-if="showMore && company.total > company.list.length" @click="onLoadMore(1)" />
          </a-spin>
        </div>
        <div class="block" v-if="current[0] == -1 && company.total"></div>
        <!-- 下面的几项使用SearchItem组件 -->
        <!-- 工作进展 -->
        <div class="content-item" v-if="(current[0] == -1 && companyNotes.total) || current[0] == 2">
          <a-spin :spinning="companyNotes.loading">
            <header>
              <span class="title">工作进展</span>
              搜索到<span class="total">{{ companyNotes.total }}</span
              >个“{{ searchWordOld }}”相关的工作进展内容
            </header>
            <common-item
              v-for="(item, index) in companyNotes.list"
              :showDivider="index < companyNotes.list.length - 1"
              :key="index"
              @clickProject="toProjectDetail(item.projectId, '工作进展')"
              :labelInfo="{ ...item, members: item.notesMembers.join(','), tagsText: item.tags.join(',') }"
              :label-config="companyNotesConfig"
            >
              <template>
                <div>工作进展：</div>
                <div v-html="item.content"></div>
              </template>
            </common-item>
            <more
              data-ga-id="搜索-点击查看更多"
              data-ga-value="工作进展"
              v-if="showMore && companyNotes.list.length < companyNotes.total"
              @click="onLoadMore(2)"
            />
          </a-spin>
        </div>
        <div class="block" v-if="current[0] == -1 && companyNotes.total"></div>
        <!-- 项目文档 -->
        <div class="content-item" v-if="(current[0] == -1 && companyFile.total) || current[0] == 3">
          <a-spin :spinning="companyFile.loading">
            <header>
              <span class="title">项目文档</span>
              搜索到<span class="total">{{ companyFile.total }}</span
              >个“{{ searchWordOld }}”相关的项目文档（专家访谈另有其垂直搜索，这里不包含）
            </header>
            <common-item
              v-for="(item, index) in companyFile.list"
              :key="item.fileId"
              :labelInfo="{ ...item }"
              :label-config="companyFileConfig"
              @clickProject="toProjectDetail(item.projectId, '项目文档')"
              @clickToPdfview="toPdfview(item, '项目文档')"
              :showDivider="index < companyFile.list.length - 1"
            >
              <template>
                <div>文档内容：</div>
                <div
                  v-html="item.content + (item.fileComments && item.fileComments.length > 0 ? '<br/>评论：<br/>' + item.fileComments.join('<br/>') : '')"
                ></div>
              </template>
            </common-item>
            <more
              data-ga-id="搜索-点击查看更多"
              data-ga-value="项目文档"
              v-if="showMore && companyFile.list.length < companyFile.total"
              @click="onLoadMore(3)"
            />
          </a-spin>
        </div>

        <div class="block" v-if="current[0] == -1 && companyFile.total"></div>

        <!-- 飞阅会评论 -->
        <div class="content-item" v-if="(current[0] == -1 && comment.total) || current[0] === 8">
          <a-spin :spinning="comment.loading">
            <header>
              <span class="title">飞阅会评论</span>
              搜索到<span class="total">{{ comment.total }}</span
              >个“{{ searchWordOld }}”相关的评论
            </header>
            <common-item
              v-for="(item, index) in comment.list"
              :key="item.fileId"
              :labelInfo="{ ...item }"
              :label-config="commentConfig"
              @clickProject="toProjectDetail(item.projectId, '飞阅会评论')"
              @clickToPdfview="toPdfview(item, '飞阅会评论')"
              :showDivider="index < comment.list.length - 1"
            >
              <template>
                <div>文档内容</div>
                <div v-html="item.content + '<br/>评论：<br/>' + item.fileComments.join('<br/>')"></div>
              </template>
            </common-item>
            <more data-ga-id="搜索-点击查看更多" data-ga-value="飞阅会评论" v-if="showMore && comment.list.length < comment.total" @click="onLoadMore(8)" />
          </a-spin>
        </div>
        <div class="block" v-if="current[0] == -1 && comment.total"></div>

        <!-- 行业专家访谈 -->
        <div class="content-item" v-if="(current[0] == -1 && expertFile.total) || current[0] == 31">
          <a-spin :spinning="expertFile.loading">
            <header>
              <span class="title">行业专家访谈</span>
              搜索到<span class="total">{{ expertFile.total }}</span
              >个“{{ searchWordOld }}”相关的专家访谈
            </header>
            <common-item
              v-for="(item, index) in expertFile.list"
              :key="item.fileId"
              :labelInfo="{ ...item, tagsText: item.tags.join(',') }"
              :label-config="expertFileConfig"
              @clickProject="toProjectDetail(item.projectId, '专家访谈')"
              @clickToPdfview="toPdfview(item, '专家访谈')"
              :showDivider="index < expertFile.list.length - 1"
            >
              <template>
                <div>访谈内容</div>
                <div v-html="item.content"></div>
              </template>
            </common-item>
            <more
              data-ga-id="搜索-点击查看更多"
              data-ga-value="行业专家访谈"
              v-if="showMore && expertFile.list.length < expertFile.total"
              @click="onLoadMore(31)"
            />
          </a-spin>
        </div>
        <div class="block" v-if="current[0] == -1 && expertFile.total"></div>

        <!-- vote -->
        <div class="content-item" v-if="(current[0] == -1 && vote.total) || current[0] == 6">
          <a-spin :spinning="vote.loading">
            <header>
              <span class="title">项目vote</span>
              搜索到<span class="total">{{ vote.total }}</span
              >个“{{ searchWordOld }}”vote记录
            </header>
            <common-item
              v-for="(item, index) in vote.list"
              :key="item.fileId"
              :labelInfo="{ ...item }"
              :label-config="voteConfig"
              @clickProject="toProjectDetail(item.projectId, 'vote')"
              @clickToPdfview="toPdfview(item, 'vote')"
              :showDivider="index < vote.list.length - 1"
            >
              <template>
                <div>vote内容</div>
                <div v-html="item.content"></div>
              </template>
            </common-item>
            <more data-ga-id="搜索-点击查看更多" data-ga-value="vote记录" v-if="showMore && vote.list.length < vote.total" @click="onLoadMore(6)" />
          </a-spin>
        </div>
        <div class="block" v-if="current[0] == -1 && vote.total"></div>

        <!-- protfolio -->
        <div class="content-item" v-if="(current[0] == -1 && portfolioFile.total) || current[0] == 7">
          <a-spin :spinning="portfolioFile.loading">
            <header>
              <span class="title">Portfolio作业</span>
              搜索到<span class="total">{{ portfolioFile.total }}</span
              >个“{{ searchWordOld }}”Portfolio作业(表格暂未支持全文搜索)
            </header>
            <common-item
              v-for="(item, index) in portfolioFile.list"
              :key="item.fileId"
              :labelInfo="{ ...item }"
              :label-config="portfolioFileConfig"
              @clickProject="toProjectDetail(item.projectId, 'portfolio')"
              @clickToPdfview="toPdfview(item, 'portfolio')"
              :showDivider="index < portfolioFile.list.length - 1"
            >
              <template>
                <div>Protfolio作业</div>
                <div v-html="item.content"></div>
              </template>
            </common-item>
            <more
              data-ga-id="搜索-点击查看更多"
              data-ga-value="portfolio作业"
              v-if="showMore && portfolioFile.list.length < portfolioFile.total"
              @click="onLoadMore(7)"
            />
          </a-spin>
        </div>
        <div class="block" v-if="current[0] == -1 && portfolioFile.total"></div>

        <!-- groupUrl -->
        <div class="content-item" v-if="(current[0] == -1 && groupUrl.total) || current[0] == 9">
          <a-spin :spinning="groupUrl.loading">
            <header>
              <span class="title">项目飞书群外链</span>
              搜索到<span class="total">{{ groupUrl.total }}</span
              >个“{{ searchWordOld }}”项目飞书群外链
            </header>
            <common-item
              v-for="(item, index) in groupUrl.list"
              :key="item.fileId"
              :labelInfo="{ ...item }"
              :label-config="groupUrlConfig"
              @clickProject="toProjectDetail(item.projectId)"
              @clickToPdfview="toPdfview(item)"
              :showDivider="index < groupUrl.list.length - 1"
            >
              <template>
                <div>飞书群外链</div>
                <div
                  v-html="item.content + '<br/>评论：<br/>' + (item.fileComments && item.fileComments.length > 0 ? item.fileComments.join('<br/>') : '')"
                ></div>
              </template>
            </common-item>
            <more v-if="showMore && groupUrl.list.length < groupUrl.total" @click="onLoadMore(9)" />
          </a-spin>
        </div>
        <div class="block" v-if="current[0] == -1 && groupUrl.total"></div>

        <!-- 共享云盘 -->
        <div class="content-item" v-if="(current[0] == -1 && file.total) || current[0] == 4">
          <a-spin :spinning="file.loading">
            <header>
              <span class="title">共享文档</span>
              搜索到<span class="total">{{ file.total }}</span
              >个“{{ searchWordOld }}”相关的文档
            </header>
            <common-item
              v-for="(item, index) in file.list"
              :key="item.fileId"
              :labelInfo="{ ...item }"
              :label-config="fileConfig"
              @clickProject="toProjectDetail(item.projectId, '共享云盘')"
              @clickToPdfview="toPdfview(item, '共享云盘')"
              :showDivider="index < file.list.length - 1"
            >
              <template>
                <div>文档内容：</div>
                <div v-html="item.content"></div>
              </template>
            </common-item>
            <more data-ga-id="搜索-点击查看更多" data-ga-value="共享文档" v-if="showMore && file.list.length < file.total" @click="onLoadMore(4)" />
            <!-- <div class="block" v-if="current[0] == -1 && file.total"></div> -->
          </a-spin>
        </div>
        <div class="main-bottom" v-if="current[0] > 0 && total > 0">
          <a-pagination
            v-if="current[0] > 0 && total > 0"
            :pageSize="current[0] === 1 ? projectPageSize : pageSize"
            size="small"
            v-model="currentPage"
            :total="total"
          />
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { search, searchNickName } from '@/api/common.js';
import { sectorList } from '@/api/sector.js';
import { ifCanAccess } from '@/api/project';
import feedback from '@/components/base/feedback';
import CommonItem from './search/item/common';
import More from './search/more';
import { feishuGroupFileList, viewResources } from '@/api/companyGroup.js';
import { checkFeishuLinkPermission } from '@/api/project';
const typeMap = {
  1: 'company',
  2: 'companyNotes',
  3: 'companyFile',
  31: 'expertFile',
  8: 'comment',
  4: 'file',
  6: 'vote',
  7: 'portfolioFile',
  9: 'groupUrl'
};
let isBefore = moment().isBefore(moment('2022-11-20'));

// 1.项目 3.项目文档 4.文档库文件类型 -1所有
const typeList = [
  { value: -1, label: '全部' },
  { value: 1, label: '项目' },
  { value: 2, label: '工作进展/log' },
  {
    value: 3,
    label: '项目文档',
    children: [
      { value: 8, label: '只搜飞阅会评论', new: isBefore },
      { value: 31, label: '只搜专家访谈' }
    ]
  },
  { value: 6, label: '项目Vote', new: isBefore },
  { value: 7, label: 'Portfolio作业', new: isBefore },
  { value: 9, label: '项目飞书群外链', new: isBefore },
  { value: 4, label: '共享云盘' }
];

const projectColumns = [
  {
    title: '公司/项目名称',
    width: '120px',
    // dataIndex: '',
    key: 'projectName',
    align: 'left',
    scopedSlots: { customRender: 'name' } // 拼头像和公司名
  },
  {
    title: '业务',
    width: '180px',
    dataIndex: 'description',
    key: 'description',
    align: 'left',
    scopedSlots: { customRender: 'brief' }
  },
  {
    title: 'sector',
    width: '60px',
    dataIndex: 'sectorName',
    key: 'sectorName',
    align: 'left'
    // scopedSlots: { customRender: 'name' }
  },
  {
    title: '币种',
    width: '80px',
    dataIndex: 'currency',
    key: 'currency',
    align: 'left'
    // scopedSlots: { customRender: 'name' }
  },
  {
    title: 'DL/DM',
    width: '60px',
    dataIndex: 'dldm',
    key: 'dldm',
    align: 'left',
    // customRender: e => {
    //   return {
    //     children: e ? e.join(',') : ''
    //   };
    // }
    scopedSlots: { customRender: 'dldm' }
  },
  {
    title: '项目阶段',
    width: '80px',
    dataIndex: 'stateName',
    key: 'stateName',
    align: 'left'
    // scopedSlots: { customRender: 'name' }
  },
  {
    title: '工商名',
    width: '72px',
    dataIndex: 'fullName',
    key: 'fullName',
    align: 'left',
    scopedSlots: { customRender: 'fullName' }
  },
  {
    title: '别名',
    width: '72px',
    dataIndex: 'thirdName',
    key: 'thirdName',
    align: 'left',
    scopedSlots: { customRender: 'thirdName' }
  },
  {
    title: '烯牛',
    width: '40px',
    dataIndex: 'xiniuUrl',
    key: 'xiniuUrl',
    align: 'left',
    scopedSlots: { customRender: 'xiniuUrl' }
  }
];

export default {
  components: {
    feedback: feedback,
    CommonItem,
    More
  },
  data() {
    return {
      projectColumns,
      feedbackVisible: false,
      typeList,
      currentPage: 1,
      pageSize: 3,
      total: 100,
      projectPageSize: 15,
      loading: false,
      searchWord: '',
      current: [-1],
      sector: 'all',
      startTime: null,
      endTime: null,
      sectorList: [],
      userList: [],

      company: {
        list: [],
        loading: false
      },
      companyNotes: {
        list: [],
        loading: false
      },
      companyFile: {
        list: [],
        loading: false
      },
      comment: {
        list: [],
        loading: false
      },
      expertFile: {
        list: [],
        loading: false
      },
      groupUrl: {
        list: [],
        loading: false
      },
      file: {
        list: [],
        loading: false
      },
      vote: {
        list: [],
        loading: false
      },
      portfolioFile: {
        list: [],
        loading: false
      },

      companyNotesConfig: [
        {
          key: 'projectName',
          clickEvent: 'clickProject',
          labelName: '项目',
          width: '20%'
        },
        {
          key: 'members',
          labelName: '进展参与人员',
          width: '20%'
        },
        {
          key: 'updateTime',

          labelName: '跟进日期',
          width: '20%'
        },
        {
          key: 'createTime',
          labelName: '创建日期',
          width: '20%'
        },
        {
          key: 'tagsText',
          labelName: '标签',
          width: '20%'
        }
      ],
      companyFileConfig: [
        {
          key: 'fileName',
          clickEvent: 'clickToPdfview',
          labelName: '项目文档',
          width: '20%'
        },
        {
          key: 'projectName',
          clickEvent: 'clickProject',
          labelName: '来自项目',
          width: '20%'
        },
        {
          key: 'fileTypeName',
          labelName: '文档类型',
          width: '20%'
        },
        {
          key: 'uploadPerson',

          labelName: '上传人员',
          width: '20%'
        },
        {
          key: 'createTime',
          labelName: '上传时间',
          width: '20%'
        }
      ],
      commentConfig: [
        {
          key: 'fileName',
          clickEvent: 'clickToPdfview',
          labelName: '项目文档',
          width: '20%'
        },
        {
          key: 'projectName',
          clickEvent: 'clickProject',
          labelName: '来自项目',
          width: '20%'
        },
        {
          key: 'fileTypeName',
          labelName: '文档类型',
          width: '20%'
        },
        {
          key: 'uploadPerson',

          labelName: '上传人员',
          width: '20%'
        },
        {
          key: 'createTime',
          labelName: '上传时间',
          width: '20%'
        }
      ],
      portfolioFileConfig: [
        {
          key: 'fileName',
          clickEvent: 'clickToPdfview',
          labelName: '项目文档',
          width: '20%'
        },
        {
          key: 'projectName',
          labelName: '来自项目',
          clickEvent: 'clickProject',
          width: '20%'
        },
        {
          key: 'uploadPerson',
          labelName: '所属作业',
          width: '20%'
        },

        {
          key: 'uploadPerson',

          labelName: '上传人员',
          width: '20%'
        },
        {
          key: 'createTime',

          labelName: '上传时间',
          width: '20%'
        }
      ],
      fileConfig: [
        {
          key: 'fileName',
          clickEvent: 'clickToPdfview',
          labelName: '文档',
          width: '25%'
        },
        {
          key: 'path',
          labelName: '文档目录',
          width: '25%'
        },

        {
          key: 'uploadPerson',

          labelName: '上传人员',
          width: '25%'
        },
        {
          key: 'createTime',

          labelName: '上传时间',
          width: '25%'
        }
      ],
      voteConfig: [
        {
          key: 'projectName',
          clickEvent: 'clickProject',
          labelName: '项目名称',
          width: '25%'
        },
        {
          key: 'roundName',
          labelName: 'vote轮次',
          width: '25%'
        },
        {
          key: 'averageScore',

          labelName: '平均分',
          width: '25%'
        },
        {
          key: 'meetingDate',
          labelName: '上会时间',
          width: '25%'
        }
      ],
      groupUrlConfig: [
        {
          key: 'fileName',
          clickEvent: 'clickToPdfview',
          labelName: '链接名称',
          width: '20%'
        },
        {
          key: 'projectName',
          clickEvent: 'clickProject',
          labelName: '来自项目',
          width: '20%'
        },

        {
          key: 'uploadPerson',
          labelName: '分享人',
          width: '20%'
        },
        {
          key: 'createTime',
          labelName: '分享时间',
          width: '20%'
        },
        {
          key: 'source',
          labelName: '外链站点',
          width: '20%'
        }
      ],
      expertFileConfig: [
        {
          key: 'fileName',
          clickEvent: 'clickToPdfview',
          labelName: '专家访谈',
          width: '20%'
        },
        {
          key: 'projectName',
          clickEvent: 'clickProject',
          labelName: '来自项目',
          width: '20%'
        },

        {
          key: 'uploadPerson',

          labelName: '上传人员',
          width: '20%'
        },
        {
          key: 'createTime',

          labelName: '上传时间',
          width: '20%'
        },
        {
          key: 'sectorName',

          labelName: 'Sector',
          width: '20%'
        },
        {
          key: 'expertEmployer',

          labelName: '专家雇主',
          width: '20%'
        },
        {
          key: 'tagsText',

          labelName: '标签',
          width: '20%'
        }
      ],
      sectorName: '全部',
      fetching: false,
      userKeyWord: '',
      userPagination: {
        page: 1,
        total: 0
      },
      userid: '',
      countMap: {
        1: 0,
        2: 0,
        3: 0,
        31: 0,
        8: 0,
        4: 0,
        6: 0,
        7: 0,
        9: 0
      }
    };
  },
  watch: {
    sector() {
      this.getList(true, true);
    },
    currentPage() {
      this.getList(false, false);
    }
  },
  computed: {
    searchWordOld() {
      return this.$route.query.searchWord;
    },
    countAll() {
      // this.countMap
      // Object.values(this.countMap).reduce((sum,e) => {
      //   return sum + e;
      // });
      return Object.values(this.countMap).reduce((sum, e) => {
        return sum + e;
      });
    },
    showMore() {
      let { current, total } = this;
      let type = current[0];
      return type === -1;
    },
    ...mapGetters(['token']),
    empty() {
      if (this.current[0] === -1) {
        let i = Object.keys(typeMap).find(key => {
          return this[typeMap[key]].list.length > 0;
        });
        return !i;
      }
      return false;
    },
    expendSelectDisable() {
      return this.current[0] !== 1 && this.current[0] !== -1;
    }
  },
  methods: {
    typeChange(e) {
      this.$ga.gaUploadCustomEvent('搜索-筛选搜索类型', e.key);
      let current = e.key;
      if (current === -1) {
        this.projectPageSize = 10;
        this.pageSize = 3;
      } else {
        this.projectPageSize = 15;
        this.pageSize = 10;
      }
      this.$nextTick(() => {
        this.getList(true, false);
      });
    },
    dropdownVisibleChange(open) {
      open && this.fetchUser('');
    },
    userChange(obj) {
      this.userid = obj;
      this.getList(true, true);
    },
    popupScroll(e) {
      // 用户列表的滚动下拉加载
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      const END = scrollHeight - scrollTop <= clientHeight;
      const GETALL = this.userList.length - 1 >= this.userPagination.total;
      if (END && !GETALL) {
        this.userPagination.page++;
        this.fetching = true;
        searchNickNamePage(this.userKeyWord, this.userPagination.page).then(res => {
          this.fetching = false;
          let list = res.data.list;
          this.userPagination.total = res.data.total;
          this.userList = this.userList.concat(list);
        });
      }
    },
    fetchUser(value) {
      this.fetching = true;
      this.userPagination.page = 1;
      searchNickName(value).then(res => {
        this.fetching = false;
        let list = res.data.list;
        this.userPagination.total = res.data.total;
        this.userPagination.page = res.data.page;
        list.unshift({ id: '', nickname: '全部' });
        this.userList = list;
        this.userKeyWord = value;
      });
    },
    async toPdfview(item, type) {
      let typeMap = {
        项目文档: 'companyFile',
        飞阅会评论: 'comment',
        专家访谈: 'expertFile'
      };
      this.$ga.gaUploadCustomEvent(`搜索-${type}-点击文档`);
      if (item.type === 9) {
        this.groupUrl.loading = true;
        let res = await viewResources({ id: item.fileId });
        this.groupUrl.loading = false;
        if (res.code === 200) {
          url = res.data.filePath;
          if (item.fileTypeId === 3 || item.fileTypeId === 0) {
            let routeLink = this.$router.resolve({ path: '/pdfview', query: { url: url + '?Authorization=' + this.token, type: res.data.viewType } });
            url = routeLink.href;
          }
          url && window.open(url);
        }
        return;
      }
      if (['folder', 'file', 'docs', 'doc', 'docx', 'sheets', 'base', 'settings', 'wiki', 'minutes'].includes(item.feishuFileType)) {
        this[typeMap[type]].loading = true;
        try {
          let res = await checkFeishuLinkPermission({
            companyFileId: item.fileId
          });
          this[typeMap[type]].loading = false;
          if (res.code === 200) {
            window.open(res.data);
          }
        } catch (e) {
          console.log(e);
        }
        this[typeMap[type]].loading = false;
        return;
      }
      let url;
      if (item.type === 4) {
        let routeLink = this.$router.resolve({ path: '/pdfview/knowledgeFile', query: { id: item.fileId } });
        url = routeLink.href;
      } else if (item.type === 3 || item.type === 31) {
        let routeLink = this.$router.resolve({ path: '/pdfview', query: { id: item.fileId, projectId: item.projectId } });
        url = routeLink.href;
      } else if (item.type === 7) {
        let routeLink = this.$router.resolve({ path: '/pdfview/finish', query: { id: item.fileId, taskId: item.portfolioTaskId } });
        url = routeLink.href;
      }
      url && window.open(url);
    },
    toProjectDetail(projectId, type) {
      this.$ga.gaUploadCustomEvent(`搜索-${type}-点击项目`);
      ifCanAccess({ id: projectId }).then(res => {
        if (res.code === 200 && res.data) {
          window.open(window.location.origin + '/project/detail?id=' + projectId);
        } else if (res.code === 200) {
          // this.$message.error('无访问权限');
          window.open(window.location.origin + `/project/detail?id=${projectId}&noPermission=true`);
        }
      });
    },
    toProject() {
      window.open(window.location.origin + '/project?searchName=' + this.searchWord);
    },
    // reset-重置页码,点加载更多/page变化/mounted处调用时传入为false,其他情况为true
    // refreshNum-重新请求总数
    async getList(reset = false, refreshNum = false) {
      if (reset) {
        this.currentPage = 1;
      }
      let { searchWord = '' } = this;
      if (!searchWord.trim()) {
        this.$message.error('请输入搜索关键词');
        return;
      }
      let data = {
        page: this.currentPage,
        pageSize: this.pageSize,
        searchWord,
        projectPageSize: this.projectPageSize,
        startTime: this.startTime.format('YYYY-MM-DD HH:mm:ss'),
        endTime: this.endTime.format('YYYY-MM-DD HH:mm:ss')
      };
      this.$router.replace({
        path: this.$route.location,
        query: {
          ...data,
          key: searchWord,
          type: this.current[0],
          random: Math.floor(Math.random() * 100000) // 无用参数 避免跳转想同路由报错
        }
      });
      if (this.sector !== 'all') {
        data.sectorId = this.sector;
      }
      if (this.user !== 'all') {
        data.userId = this.userid;
      }
      this.searchData = data;
      this.loading = true;
      if (this.current[0] === -1) {
        Promise.all(Object.keys(typeMap).map(type => this.getTypeList(type))).then(() => {
          this.loading = false;
        });
      } else {
        if (refreshNum) {
          this.getTotalNum();
        }
        this.getTypeList(this.current[0]).then(() => {
          this.loading = false;
        });
      }
    },
    async getTypeList(type) {
      try {
        this[typeMap[type]].loading = true;
        this[typeMap[type]].list = [];
        let params = { ...this.searchData, type };
        const res = await search({ ...params });
        if (res.code === 200) {
          let list =
            res.data.list &&
            res.data.list.map(i => {
              return {
                ...i,
                content: i.content || ''
              };
            });

          this[typeMap[type]] = {
            ...res.data,
            list: list || [],
            loading: false
          };
          this.countMap[type] = res.data.total;
          document.querySelector('.ant-layout-content').scrollTop = 0;
          this.total = res.data.total;
        } else {
          this[typeMap[type]].loading = false;
        }
      } catch (error) {
        this[typeMap[type]].loading = false;
      }
    },
    async getTotalNum() {
      let { searchWord = '' } = this;
      let arr = Object.keys(typeMap);
      let data = {
        page: 1,
        pageSize: 1,
        searchWord,
        projectPageSize: 1,
        startTime: this.startTime.format('YYYY-MM-DD HH:mm:ss'),
        endTime: this.endTime.format('YYYY-MM-DD HH:mm:ss')
      };
      if (this.sector !== 'all') {
        data.sectorId = this.sector;
      }
      if (this.user !== 'all') {
        data.userId = this.userid;
      }

      arr.forEach(type => {
        let params = {
          ...data,
          type
        };

        return search(params).then(res => {
          this.countMap[type] = res.data.total;
        });
      });
    },
    onLoadMore(current) {
      this.currentPage = 1;
      this.pageSize = 10;
      this.current = [current];
      this.getList(true, false);
    },
    toXiniu(url) {
      window.open(url);
    },
    async getSelects() {
      const res = await sectorList();
      if (res.code === 200) {
        this.sectorList = res.data.filter(_ => {
          return _.status === 'NORMAL';
        });
      }
    }
  },
  mounted() {
    this.getSelects();
    if (this.$route.query.key) {
      this.searchWord = this.$route.query.key;
      let query = this.$route.query;
      query.page && (this.currentPage = parseInt(query.page));
      query.pageSize && (this.pageSize = parseInt(query.pageSize));
      query.projectPageSize && (this.projectPageSize = parseInt(query.projectPageSize));
      query.startTime && (this.startTime = moment(query.startTime, 'YYYY-MM-DD HH:mm:ss'));
      query.endTime && (this.endTime = moment(query.endTime, 'YYYY-MM-DD HH:mm:ss'));
      query.type && this.$set(this.current, 0, parseInt(query.type));
      // 不reset page, 是页面加载第一次请求
      this.getList(false, true);
    } else {
      this.getList();
    }
  },
  created() {
    this.startTime = moment('2014-01-01 00:00:00', 'YYYY-MM-DD HH:mm:ss');
    this.endTime = moment();
  }
};
</script>
<style>
.overlay-text {
  font-size: 14px;
  max-width: 200px;
}
</style>
<style lang="less" scoped>
// @import url('../components/project/task.less');
.search-bar {
  padding: 20px 20px;
  border-bottom: 1px solid #e8e8e8;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 0px 20px;
  z-index: 100;
}
.layout-max {
  font-size: 14px;
  background-color: white;
  height: 100%;
}
.avatar {
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
}
.img-24 {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-color: #eee;
  background-size: 24px 24px;
  margin-right: 6px;
}
.layout {
  height: calc(100vh - 124px);
  // padding-bottom: 20px;
}
.share-layout {
  height: calc(100vh - 72px);
  // padding-bottom: 20px;
}
.list-box {
  height: 100%;
}
.expertPath {
  width: calc(100% + 1px - 15px);
  margin-left: 15px;
  border-left: 1px solid rgb(205, 205, 205);
}
.new {
  background-color: #f00;
  color: #fff;
  // margin-left: 5px;
  padding: 0 3px;
  font-size: 12px;
  border-radius: 2px;
  display: inline-block;
  transform: scale(0.8);
  height: 18px;
  line-height: 18px;
  margin-right: -6px;
}
.content-item {
  padding: 20px;
  margin: 20px;
  background-color: white;
  /deep/ .ant-table-column-title {
    font-weight: 500;
  }

  header {
    .title {
      color: rgba(0, 0, 0, 0.85);
      font-weight: 700;
      font-size: 16px;
      margin-right: 4px;
    }
    margin-bottom: 20px;
    &::before {
      content: '|';
      display: inline-block;
      width: 4px;
      height: 100%;
      background-color: @blue;
      margin-right: 8px;
      font-weight: 900;
      color: @blue;
      // zoom: 0.8;
      transform: scale(0.8) translateY(-1px);
    }
  }
  .total {
    color: @blue;
    margin: 0 4px;
  }
  .note-header {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .note-header-item {
      width: 20%;
      margin-bottom: 10px;
      label {
        color: #999;
      }
      span {
        color: #333;
      }
    }
  }
  .note-item {
    padding: 8px;
    background-color: rgba(0, 0, 0, 2%);
    width: 100%;
    line-height: 24px;
    .content {
      display: -webkit-box;
      -webkit-line-clamp: 4;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      white-space: normal;
    }
  }

  .note-more {
    margin-top: 7px;
    height: 15px;
    span {
      float: right;
      cursor: pointer;
      text-decoration: underline;
      color: rgba(57, 164, 255, 0.5);
    }
  }
}
.main-bottom {
  padding: 0 32px 20px 32px;
  margin: -20px 20px 20px 20px;
  display: flex;
  justify-content: flex-end;
  background-color: white;
}
.block {
  display: none;
  width: 100%;
  height: 20px;
  background-color: #f0f2f5;
}

.feedback {
  position: absolute;
  right: 10px;
  top: 50%;
  color: red;
  transform: translateY(-50%);
}
.count {
  // font-size: 12px;
  color: @golden;
  margin: 0 8px;
}
.text-over {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.project-name {
  /deep/ span {
    font-weight: 700;
  }
}
/deep/.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-tbody > tr > td {
  padding: 6px 8px;
}
</style>
